<template>
  <van-dialog v-model="dialogShows" title="" @confirm="handConfirm">
    <div class="icon-box">
      <van-icon name="warning-o" size="60px" color="#E0620D" />
    </div>
    <div class="content">
      {{ dataMsg }}
    </div>
  </van-dialog>
</template>

<script>
import { Dialog,Icon } from 'vant';
export default {
  components:{
    [Dialog.Component.name]: Dialog.Component,
    [Icon.name]:Icon
  },
  props:{
    dialogShow:{
      type:Boolean,
      default:() =>{
        return false
      }
    },
    dataMsg:{
      type:String,
      default:() =>{
        return ''
      }
    }
  },
  watch:{
    dialogShow(val){
      this.dialogShows = val
    }
  },
  data(){
    return {
      dialogShows:false
    }
  },
  methods:{
    handConfirm(){
      this.$emit('update',true)
    }
  }
}
</script>

<style scoped lang="less">
    .icon-box{
      width: 100%;
      height: 80px;
      text-align: center;
      margin-top: 40px;
    }
    .content{
      margin-top: 60px;
      padding-left: 20px;
      margin-bottom: 40px;
      padding-right: 20px;
      font-size: 28px;
    }
</style>
